import image1 from  "../assets/download (2).jpeg" ;
import image2 from  "../assets/download (3).jpeg" ;
import image6 from  "../assets/images.jpeg" ;
import image4 from  "../assets/download (5).jpg" ;
import image5 from  "../assets/download (4).jpeg" ;
import image7 from  "../assets/hydro test.jpeg" ;


const ProjectCardData = [
    {
        img: image1 ,
        title: "Procurement :",
        text: "All Procurement activities are carried out in accordance with established standards and specifications, ensuring timely sourcing of quality materials, equipment, and services from approved vendors. All purchases will be properly documented and aligned with project requirements, budget provisions, and regulatory compliance..",
        view: "/contact",
        source: "/contact"
    },
    {
        img: image2 ,
        title: " Logistics and Marine Services:",
        text: "Our Marine and logistics operations are efficiently coordinated to ensure the safe and timely transportation of materials, equipment, and personnel to and from the site. All activities comply with applicable safety standards and regulatory requirements, with proper planning to minimize delays and ensure seamless project execution .",
        view: "/contact",
        source: "/contact"
    },
    {
        img: image4 ,
        title: "Civil Construction/Mechanical works :",
        text: "All Civil construction and mechanical works are executed in accordance with approved drawings, specifications, and industry standards. All activities are carried out by qualified personnel using appropriate equipment to ensure structural integrity, quality workmanship, and compliance with safety and regulatory requirements.",
        view: "/contact",
        source: "/contact"
    },
    {
        img: image5 ,
        title: "Pipeline Services :",
        text: "Our Pipeline services are executed in accordance with approved specifications and industry best practices, including installation, inspection, testing, and maintenance. All activities are being carried out by qualified personnel using appropriate equipment to ensure integrity, safety, and compliance with regulatory requirements.",
        view: "/contact",
        source: "/contact"
    },
    {
        img: image6 ,
        title: "Labour Supply :",
        text: "All Labour supply are be managed to ensure the availability of skilled and unskilled personnel as required for timely project execution. All personnel will be properly vetted, competent, and compliant with safety standards and regulatory requirements, ensuring efficient and quality service delivery.",
        view: "/contact",
        source: "/contact"
    },
    {
        img: image7 ,
        title: "Hydro-Test Services :",
        text:  "All Hydro-test services are being conducted in accordance with approved procedures and industry standards to verify the integrity and strength of pipelines and associated systems. All testing activities will be performed by qualified personnel using calibrated equipment, ensuring safety, accuracy, and full compliance with regulatory requirements..",
        view: "/contact",
        source: "/contact"
    }
];

export default ProjectCardData;